import window from 'window-or-global';
import BootstrapManager from '../bootstrap/tinymce-bootstrap';

export const exportAjsRteBootstrapManagerAsGlobal = () => {
	if (typeof window.AJS.Rte === 'undefined') {
		if (process.env.NODE_ENV !== 'production') {
			console.error('AJS.Rte is supposed to be defined');
		}
		return;
	}
	if (typeof window.AJS.Rte.BootstrapManager === 'undefined') {
		window.AJS.Rte.BootstrapManager = BootstrapManager;
	}
};
